module.exports = __webpack_public_path__ + "img/4.0a8abbd8.jpg";